import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/core/base/base.component';
import { TURN } from '../turn.constants';
import { TurnDialogService } from './turn.dialog.service';

@Component({
  selector: 'ms-common-turn-comment-dialog',
  templateUrl: './turn.comment-dialog.component.html',
})
export class TurnCommentDialogComponent extends BaseComponent {

  readonly screen = TURN;
  private patient = 0;
  comments = '';

  constructor(
    protected ref: DynamicDialogRef,
    protected config: DynamicDialogConfig,
    protected service: TurnDialogService
  ) {
    super();
  }

  onInit = () => {
    this.patient = this.config.data.patient;
    this.comments = this.config.data.comments;
  }

  save = () => {
    this.service.setLoadingState();
    this.subscriptions.push(
      this.service.addComment(this.patient, this.comments).subscribe(() => {
        const { data: turn } = this.config;
        turn.comment = this.comments;
        this.ref.close(turn);
      })
    );
  }

}
